module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "timeline-separator",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1"
    }
  }, [_c('rect', {
    attrs: {
      "x": "9",
      "y": "0",
      "width": "2",
      "height": "100%"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df3a39a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Timeline/TimelineSeparator.vue
// module id = 302
// module chunks = 1